module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "Mario.7a73307c.png";